import { render } from "./Additionals.vue?vue&type=template&id=08b47766"
import script from "./Additionals.vue?vue&type=script&lang=js"
export * from "./Additionals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__